import React, { useId, useState } from "react";
import { ChevronDown } from "lucide-react";
type CollapsibleItemProps = {
  header: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
};
export function CollapsibleItem({
  header,
  children,
  defaultOpen = false
}: CollapsibleItemProps) {
  const [open, setOpen] = useState(defaultOpen);
  const contentId = useId();
  return <div className="overflow-hidden rounded-2xl border border-white/10 bg-[#0A1830] shadow-[0_14px_38px_rgba(0,0,0,0.22)] transition-colors duration-200 hover:border-[#F5B83D]/25" data-id="element-36" data-mp="1tkmwh8awlnhh">
      <button type="button" aria-expanded={open} aria-controls={contentId} onClick={() => setOpen(value => !value)} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-200 hover:bg-white/[0.03] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5B83D]/60 sm:px-6 sm:py-6" data-id="element-37" data-mp="1xocgrlkjpiwp">
        {header}
        <span className={`flex size-9 shrink-0 items-center justify-center rounded-full border border-white/10 bg-[#0B3563] transition-transform duration-300 ease-out ${open ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-38" data-mp="2hc25fjx6r31p">
          <ChevronDown className="size-4 text-white" data-id="element-39" data-mp="17efhbx61kasu" />
        </span>
      </button>
      <div id={contentId} className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
      gridTemplateRows: open ? "1fr" : "0fr"
    }} data-id="element-40" data-mp="12m5oo9djkwmv">
        <div className="overflow-hidden" data-id="element-41" data-mp="1ccqsqcbzitd6">{children}</div>
      </div>
    </div>;
}